const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Plumbing Services',
      description: 'Complete plumbing solutions for residential and commercial properties. From leak repairs to full installations.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Repairs',
      description: 'Expert bathroom repair and renovation services. Toilets, washbasins, showers, and complete bathroom makeovers.',
    },
    {
      icon: 'ri-fire-line',
      title: 'Heating System Replacement',
      description: 'Modern heating system installations and replacements. Energy-efficient solutions for your home comfort.',
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Underfloor Heating',
      description: 'Professional underfloor heating installation. Efficient, comfortable, and space-saving heating solutions.',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Radiator Replacement',
      description: 'Quality radiator installation and replacement services. Modern designs with optimal heat distribution.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Heat Pump Maintenance',
      description: 'Comprehensive heat pump servicing and maintenance. Keep your system running efficiently year-round.',
    },
  ];

  return (
    <section id="services" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-3">
            OUR EXPERTISE
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            Comprehensive Heating &amp; Plumbing Solutions
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            From emergency repairs to complete installations, we deliver professional plumbing and heating services  with guaranteed quality and customer satisfaction.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-accent/10 rounded-full mb-6 group-hover:bg-accent transition-colors">
                <i className={`${service.icon} text-3xl text-accent group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <a href="#contact" className="inline-flex items-center space-x-2 text-accent hover:text-accent-dark font-medium text-sm transition-colors whitespace-nowrap">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;